import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AdditionalInformation from './containers/AdditionalInformation/AdditionalInformation';
import DebtorsList from './containers/DebtorsList/DebtorsList';
import DetailsList from './containers/DetailsList/DetailsList';
import ImportantDates from './containers/ImportantDates/ImportantDates';

import { resetState } from '@actions/importantDates';

import './CaseDetails.scss';

class CaseDetails extends React.Component {
  componentDidMount() {
    this.props.resetImportantDatesState();
  }

  render() {
    return (
      <div className="case-details">
        <div>
          <DetailsList />
        </div>
        <div className="case-details__important-dates">
          <ImportantDates />
        </div>
        <div className="case-details__additional-information">
          <AdditionalInformation />
        </div>
        <div className="case-details__debtors">
          <DebtorsList />
        </div>
      </div>
    );
  }
}

CaseDetails.propTypes = {
  resetImportantDatesState: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  resetImportantDatesState: resetState,
}, dispatch);

export default connect(null, mapDispatchToProps)(CaseDetails);



// WEBPACK FOOTER //
// ./src/routes/Case/Details/CaseDetails.js